var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m18.598 16.563-1.545-1.823c-.42-.486-.865-.782-1.328-.31l-.927.884c-.713.797-1.283.505-1.923-.017l-3.481-4.309c-.42-.485-.461-1.078.002-1.55l1.283-1.282c.464-.473.21-.982-.21-1.467L8.268 4.34c-.42-.487-.962-.429-1.425.044C5.92 5.33 5.27 6.494 5.06 7.93c-.258 1.75.358 3.98 1.36 5.15.304.356 3.558 4.403 4.38 5.34 1.103 1.252 2.803 1.723 4.43 1.543 1.333-.148 2.565-.95 3.493-1.896.463-.47.297-1.018-.124-1.504",
    clipRule: "evenodd"
  })));
});
const SvgOldPhoneFilled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOldPhoneFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC41OTc4IDE2LjU2MzJMMTcuMDUyOCAxNC43NDAyQzE2LjYzMjggMTQuMjU0MiAxNi4xODc4IDEzLjk1ODIgMTUuNzI0OCAxNC40MzAyTDE0Ljc5NzggMTUuMzE0MkMxNC4wODQ4IDE2LjExMTIgMTMuNTE0OCAxNS44MTkyIDEyLjg3NDggMTUuMjk3Mkw5LjM5Mzc3IDEwLjk4ODJDOC45NzM3NyAxMC41MDMyIDguOTMyNzcgOS45MTAxNiA5LjM5NTc3IDkuNDM4MTZMMTAuNjc4OCA4LjE1NjE2QzExLjE0MjggNy42ODMxNiAxMC44ODg4IDcuMTc0MTYgMTAuNDY4OCA2LjY4OTE2TDguMjY3NzcgNC4zMzgxNkM3Ljg0Nzc3IDMuODUyMTYgNy4zMDU3NyAzLjkxMDE2IDYuODQyNzcgNC4zODMxNkM1LjkxOTc3IDUuMzMwMTYgNS4yNzA3NyA2LjQ5NDE2IDUuMDU5NzcgNy45MzAxNkM0LjgwMTc3IDkuNjgwMTYgNS40MTc3NyAxMS45MTAyIDYuNDE5NzcgMTMuMDgwMkM2LjcyMzc3IDEzLjQzNjIgOS45Nzc3NyAxNy40ODMyIDEwLjc5OTggMTguNDE5MkMxMS45MDI4IDE5LjY3MjIgMTMuNjAyOCAyMC4xNDMyIDE1LjIyOTggMTkuOTYzMkMxNi41NjI4IDE5LjgxNTIgMTcuNzk0OCAxOS4wMTIyIDE4LjcyMjggMTguMDY3MkMxOS4xODU4IDE3LjU5NjIgMTkuMDE5OCAxNy4wNDkyIDE4LjU5ODggMTYuNTYzMiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";